const ACTIONS = {
    REQUEST_TO_BOOK: 'CHATBOT/REQUEST_TO_BOOK',
    TRIGGER_CHAT_EXIT_TOAST: 'CHATBOT/TRIGGER_CHAT_EXIT_TOAST'
};

const ACTION_CREATORS = {
    chatbotRequestToBook() {
        return {
            type: ACTIONS.REQUEST_TO_BOOK,
            payload: {}
        };
    },
    triggerChatExitToast(element, onClose) {
        return {
            type: ACTIONS.TRIGGER_CHAT_EXIT_TOAST,
            payload: {
                element,
                onClose
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
